export const MARKET_OPTIONS = [
  { symbol: "XAUUSD", label: "XAU/USD", type: "metals", seedPrice: 2362, volatility: 6.5 },
  { symbol: "EURUSD", label: "EUR/USD", type: "forex", seedPrice: 1.0842, volatility: 0.0014 },
  { symbol: "GBPUSD", label: "GBP/USD", type: "forex", seedPrice: 1.2671, volatility: 0.0018 },
  { symbol: "USDJPY", label: "USD/JPY", type: "forex", seedPrice: 155.42, volatility: 0.12 },
  { symbol: "AUDUSD", label: "AUD/USD", type: "forex", seedPrice: 0.6618, volatility: 0.0012 },
  { symbol: "USDCAD", label: "USD/CAD", type: "forex", seedPrice: 1.3662, volatility: 0.0013 },
  { symbol: "BTCUSDT", label: "BTC/USD", type: "crypto", seedPrice: 65000, volatility: 120 },
  { symbol: "ETHUSDT", label: "ETH/USD", type: "crypto", seedPrice: 3150, volatility: 18 },
  { symbol: "SOLUSDT", label: "SOL/USD", type: "crypto", seedPrice: 145, volatility: 2.8 },
  { symbol: "BNBUSDT", label: "BNB/USD", type: "crypto", seedPrice: 585, volatility: 4.6 },
  { symbol: "NAS100", label: "NAS100", type: "indices", seedPrice: 18542, volatility: 28 },
  { symbol: "US30", label: "US30", type: "indices", seedPrice: 39220, volatility: 42 },
  { symbol: "SPX500", label: "SPX500", type: "indices", seedPrice: 5275, volatility: 11 },
  { symbol: "GER40", label: "GER40", type: "indices", seedPrice: 18420, volatility: 25 },
  { symbol: "UK100", label: "UK100", type: "indices", seedPrice: 8295, volatility: 10 },
];

export const BOT_PROFILES = {
  lowRisk: {
    id: "lowRisk",
    label: "Low Risk Bot",
    description: "Conservative entries, tighter RSI threshold, fewer DCA layers.",
    accent: "emerald",
    entryRsi: 28,
    dcaTriggerPercent: 1.35,
    takeProfitPercent: 1.6,
    stopLossPercent: 2.6,
    maxDcaOrders: 2,
    confidenceBias: 54,
    executionChance: 0.48,
  },
  mediumRisk: {
    id: "mediumRisk",
    label: "Medium Risk Bot",
    description: "More aggressive entries with faster DCA stacking and higher activity.",
    accent: "amber",
    entryRsi: 34,
    dcaTriggerPercent: 0.95,
    takeProfitPercent: 2.3,
    stopLossPercent: 3.4,
    maxDcaOrders: 4,
    confidenceBias: 62,
    executionChance: 0.64,
  },
};

export const CYCLE_OPTIONS = [
  { value: "15s", label: "15 Seconds" },
  { value: "1m", label: "1 Minute" },
  { value: "3m", label: "3 Minutes" },
  { value: "5m", label: "5 Minutes" },
  { value: "15m", label: "15 Minutes" },
];

export const BOT_STATE_META = {
  scanning: { label: "Scanning Market", tone: "text-cyan-300", dot: "bg-cyan-400" },
  waiting: { label: "Waiting for Entry", tone: "text-sky-300", dot: "bg-sky-400" },
  executingBuy: { label: "Executing Buy", tone: "text-emerald-300", dot: "bg-emerald-400" },
  monitoring: { label: "Monitoring Position", tone: "text-violet-300", dot: "bg-violet-400" },
  executingDca: { label: "Executing DCA", tone: "text-amber-300", dot: "bg-amber-400" },
  takingProfit: { label: "Taking Profit", tone: "text-green-300", dot: "bg-green-400" },
  closed: { label: "Trade Closed", tone: "text-emerald-300", dot: "bg-emerald-400" },
  paused: { label: "Paused", tone: "text-yellow-300", dot: "bg-yellow-400" },
  stopped: { label: "Stopped", tone: "text-rose-300", dot: "bg-rose-400" },
};

export const getMarketBySymbol = (symbol) =>
  MARKET_OPTIONS.find((market) => market.symbol === symbol) || MARKET_OPTIONS[0];

export const isCryptoMarket = (symbol) => getMarketBySymbol(symbol).type === "crypto";
